import { createContext } from "react";

export const WeatherContext = createContext({
   unit:{} ,
   setUnit:()=>{},
   darkMode:{},
   setDarkMode:()=>{},
   weatherData:{},
   setWeatherData:()=>{},
})